// Animation configuration for the application
export const animationConfig = {
  // Feature toggle for page transitions
  // Set to true to enable smooth page transitions
  // Set to false to disable animations and prevent flashing
  enablePageTransitions: false,
  
  // Feature toggle for component animations (staggered loading effects)
  // Set to false to prevent staggered loading appearance
  enableComponentAnimations: false,
  
  // Animation settings (when enabled)
  transitions: {
    // Fast transitions for better UX
    duration: 0.15,
    ease: "easeInOut",
    
    // Background-aware animations (no white flash)
    pageEnter: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 }
    },
    
    // Alternative slide animation (smoother option)
    pageSlide: {
      initial: { opacity: 0, x: -20 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: 20 }
    }
  },
  
  // Component animation settings
  components: {
    // Fast, simultaneous loading
    duration: 0.1,
    ease: "easeOut",
    staggerDelay: 0, // No stagger = simultaneous
  }
};

// Utility to get animation props based on config
export const getPageAnimation = () => {
  if (!animationConfig.enablePageTransitions) {
    return {};
  }
  
  return {
    ...animationConfig.transitions.pageEnter,
    transition: {
      duration: animationConfig.transitions.duration,
      ease: animationConfig.transitions.ease
    }
  };
};

// Utility to get component animation props
export const getComponentAnimation = (delay = 0) => {
  if (!animationConfig.enableComponentAnimations) {
    return {};
  }
  
  return {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: {
      duration: animationConfig.components.duration,
      ease: animationConfig.components.ease,
      delay: animationConfig.components.staggerDelay * delay
    }
  };
};